import React, {useState} from 'react';
import {useNavigate} from "react-router-dom";
import {handleActiveError, handleActiveToast} from "../../../../components/sonner/ToastBasic";
import {validationChecker} from "../../../../components/commonmethod/CommonMethod";
import {createPurchase} from "../../../../api/asset/PurchaseService";
import {useSelector} from "react-redux";
import Th_title from "../../../../components/Th_title";
import {CodeSpecNum, UserType} from "../../../../constant/CodeSpecNum";
import {inputOnChange} from "../../../../components/commonmethod/simmsInputMethod";
import SimmsInput from "../../../../components/input/SimmsInput";
import Selector from "../../../../components/selector/Selector";
import SearchSelector from "../../../../components/searchSelector/SearchSelector";
import UserSelectionField from "../../../../components/selection/UserSelectionField";
import {AssetSearchFilters} from "../info/shared/AssetSearchFilters";
import {onCreateClickListener} from "../../../../components/commonmethod/simmsDrawerMethod";
import SimmsTextArea from "../../../../components/input/SimmsTextArea";
import {dateOnChange} from "../../../../components/commonmethod/simmsDateMethod";
import SimmsDatePicker from "../../../../components/datepicker/SimmsDatePicker";
import SimmsInputSearch from "../../../../components/input/SimmsInputSearch";
import SimmsDrawerSearch from "../../../../components/drawer/simms/SimmsDrawerSearch";
import {
    ContentDetailTwoColLayout,
    DetailFilePanel,
    DetailFormPageShell,
    DetailKvReadOnly,
    DetailKvTable,
    DetailListPage,
    DetailPanel,
    DetailSummaryButton,
} from "../../../../components/detailLayout";
import "../../../../components/detailLayout/detailListLayout.css";

function PurchaseCreate() {
    const platFrom = useSelector(state => state.auth.platFrom);
    const user = useSelector((state) => state.auth.user);
    const currentDate = new Date();
    const [docs, setDocs] = useState([]);
    const [purchase, setPurchase] = useState({asset: []});
    const navigate = useNavigate();

    const create = async () => {
        const purchaseAsset = [];
        purchase?.asset?.forEach(asset => {
            purchaseAsset.push({asset: {id: asset.id}});
        });

        purchase.assets = purchaseAsset;

        if (validationChecker(purchase)) {
            if (purchase.handler?.length === 0 || purchase.handler === undefined) {
                handleActiveError({message: "필수값인 담당자가 누락되었습니다."});
            } else {
                const docFile = [];
                docs.forEach(each => docFile.push(each.object));
                createPurchase(purchase, docFile).then(_ => {
                    if (_.status === 200) {
                        handleActiveToast({message: "등록되었습니다."});
                        navigate(`/asset/purchase/${_.data.id}`, {state: {id: _.data.id}});
                    } else if (_.status === (201 | 202)) {
                        handleActiveError({message: _.data.title, description: _.data.reason});
                    }
                }).catch(() => {
                    handleActiveError({message: "등록에 실패했습니다."});
                });
            }
        }
    };

    return (
        <DetailFormPageShell
            className="common-container container-height-full border-l-gray create-page detail-list-layout asset-detail-list-layout"
            title="구매 등록"
            meta="신규 구매 정보를 입력하세요"
            actions={
                <>
                    <DetailSummaryButton muted onClick={() => navigate("/asset/purchase")}>
                        취소
                    </DetailSummaryButton>
                    <DetailSummaryButton
                        onClick={() => {
                            if (window.confirm("등록 하시겠습니까?")) {
                                create();
                            }
                        }}
                    >
                        등록
                    </DetailSummaryButton>
                </>
            }
        >
            <DetailListPage isEditing className="flex min-h-0 flex-1 flex-col">
                <div className="container-height-body asset-detail-body detail-list-body flex min-h-0 flex-1 flex-col overflow-hidden">
                    <ContentDetailTwoColLayout
                        main={
                        <DetailPanel title="기본정보">
                            <DetailKvTable>
                                <tbody>
                                <tr>
                                    <DetailKvReadOnly label="등록일시" value={currentDate.toISOString()} type="date"/>
                                    <DetailKvReadOnly label="수정일시" value=""/>
                                </tr>
                                <tr>
                                    <DetailKvReadOnly label="등록자" value={user.name}/>
                                    <DetailKvReadOnly label="수정자" value=""/>
                                </tr>
                                <tr>
                                    <Th_title title="구매정보 명칭" colspan={1} required className="fieldset-td" auth>
                                        <SimmsInput
                                            onChange={(v) => inputOnChange(setPurchase, "title", v, true)}
                                            data={purchase.title}
                                        />
                                    </Th_title>
                                    <Th_title title="구매번호" colspan={1} className="fieldset-td" auth>
                                        <SimmsInput
                                            onChange={(v) => inputOnChange(setPurchase, "purchaseNumber", v, false)}
                                            data={purchase.purchaseNumber}
                                        />
                                    </Th_title>
                                </tr>
                                <tr>
                                    <Th_title title="업체명" colspan={1} className="fieldset-td" auth>
                                        <Selector
                                            onChange={(v) => onCreateClickListener(setPurchase, "company", purchase.company, v)}
                                            data={purchase.company}
                                            entity="company"
                                        >
                                            <SimmsInputSearch type="TEXT" placeHolder="업체명"/>
                                        </Selector>
                                    </Th_title>
                                    <Th_title
                                        title="담당자"
                                        colspan={1}
                                        className="fieldset-td fieldset-td-input relative align-top"
                                        required
                                        auth
                                    >
                                        <UserSelectionField
                                            layout="inline"
                                            data={purchase.handler}
                                            onRemove={(v) =>
                                                setPurchase((prev) => ({
                                                    ...prev,
                                                    handler: (prev.handler ?? []).filter((h) => h.id !== v.id),
                                                }))
                                            }
                                        >
                                            <SearchSelector
                                                auth
                                                multiSelect
                                                variant="compact"
                                                entity="userAccount"
                                                uniqueKey={UserType.handlers}
                                                data={purchase.handler}
                                                placeHolder="사용자명"
                                                onChange={(v) => {
                                                    if (v?.__multiFlat) {
                                                        setPurchase((prev) => ({...prev, handler: v.__multiFlat}));
                                                    }
                                                }}
                                            >
                                                <SimmsInputSearch type="TEXT" placeHolder="사용자명"/>
                                                <SimmsDrawerSearch showLabel title="부서" entity="department" target="department" recursive/>
                                                <SimmsDrawerSearch showLabel title="업체" entity="company" target="company"/>
                                            </SearchSelector>
                                        </UserSelectionField>
                                    </Th_title>
                                </tr>
                                <tr className="asset-detail-kv-row--auto">
                                    <Th_title title="구매 일시" colspan={1} className="fieldset-td" auth>
                                        <SimmsDatePicker
                                            onChange={(v) => dateOnChange(setPurchase, "purchaseStartDate", v, false)}
                                            data={purchase.purchaseStartDate}
                                        />
                                    </Th_title>
                                    <Th_title title="자산목록" colspan={1} className="fieldset-td relative align-top" auth>
                                        <UserSelectionField
                                            layout="inline"
                                            data={purchase.asset}
                                            countUnit="개"
                                            chipEntity="asset"
                                            listModalTitle="자산목록"
                                            onRemove={(v) =>
                                                setPurchase((prev) => ({
                                                    ...prev,
                                                    asset: (prev.asset ?? []).filter((a) => a.id !== v.id),
                                                }))
                                            }
                                        >
                                            <SearchSelector
                                                auth
                                                multiSelect
                                                variant="compact"
                                                entity="asset"
                                                uniqueKey="assets"
                                                data={purchase.asset}
                                                placeHolder="자산명"
                                                onChange={(v) => {
                                                    if (v?.__multiFlat) {
                                                        setPurchase((prev) => ({...prev, asset: v.__multiFlat}));
                                                    }
                                                }}
                                            >
                                                <AssetSearchFilters platFrom={platFrom}/>
                                            </SearchSelector>
                                        </UserSelectionField>
                                    </Th_title>
                                </tr>
                                <tr>
                                    <Th_title title="공급방법(도입방법)" className="fieldset-td" colspan={1} auth>
                                        <Selector
                                            onChange={(v) => onCreateClickListener(setPurchase, "method", purchase.method, v)}
                                            data={purchase.method}
                                            entity="code"
                                            parentKey={CodeSpecNum.PurchaseSupplyMethodCode}
                                            recursive
                                        />
                                    </Th_title>
                                    <Th_title title="공급구분(도입형태)" className="fieldset-td" colspan={1} auth>
                                        <Selector
                                            onChange={(v) => onCreateClickListener(setPurchase, "category", purchase.category, v)}
                                            data={purchase.category}
                                            entity="code"
                                            parentKey={CodeSpecNum.PurchaseSupplyCategoryCode}
                                            recursive
                                        />
                                    </Th_title>
                                </tr>
                                <tr>
                                    <Th_title title="구매 수량" colspan={1} className="fieldset-td" auth>
                                        <SimmsInput
                                            onChange={(v) => inputOnChange(setPurchase, "purchaseQuantity", v, false)}
                                            data={purchase.purchaseQuantity}
                                            constraint={{type: "number"}}
                                        />
                                    </Th_title>
                                    <Th_title title="사용년수(내용연수)" colspan={1} className="fieldset-td" auth>
                                        <SimmsInput
                                            onChange={(v) => inputOnChange(setPurchase, "yearsUse", v, false)}
                                            data={purchase.yearsUse}
                                            constraint={{type: "number"}}
                                        />
                                    </Th_title>
                                </tr>
                                <tr>
                                    <Th_title title="구매 단가" colspan={1} className="fieldset-td" auth>
                                        <SimmsInput
                                            onChange={(v) => inputOnChange(setPurchase, "purchasePrice", v, false)}
                                            data={purchase.purchasePrice}
                                            constraint={{type: "number"}}
                                        />
                                    </Th_title>
                                    <Th_title title="구매총금액(VAT포함)" colspan={1} className="fieldset-td" auth>
                                        <SimmsInput
                                            onChange={(v) => inputOnChange(setPurchase, "purchaseTotalPrice", v, false)}
                                            data={purchase.purchaseTotalPrice}
                                            constraint={{type: "number"}}
                                        />
                                    </Th_title>
                                </tr>
                                <tr>
                                    <Th_title title="년 유지보수금액" colspan={1} className="fieldset-td" auth>
                                        <SimmsInput
                                            onChange={(v) => inputOnChange(setPurchase, "maintenancePriceYear", v, false)}
                                            data={purchase.maintenancePriceYear}
                                            constraint={{type: "number"}}
                                        />
                                    </Th_title>
                                    <Th_title title="월 유지보수금액" colspan={1} className="fieldset-td" auth>
                                        <SimmsInput
                                            onChange={(v) => inputOnChange(setPurchase, "maintenancePriceMonth", v, false)}
                                            data={purchase.maintenancePriceMonth}
                                            constraint={{type: "number"}}
                                        />
                                    </Th_title>
                                </tr>
                                <tr>
                                    <Th_title title="유지보수 요율(%)" colspan={3} className="fieldset-td" auth>
                                        <SimmsInput
                                            onChange={(v) => inputOnChange(setPurchase, "maintenanceTariff", v, false)}
                                            data={purchase.maintenanceTariff}
                                            constraint={{type: "number"}}
                                        />
                                    </Th_title>
                                </tr>
                                <tr>
                                    <Th_title title="비고사항" colspan={3} className="fieldset-td" auth>
                                        <SimmsTextArea
                                            onChange={(v) => inputOnChange(setPurchase, "etc", v, false)}
                                            data={purchase.etc}
                                            style={{width: "100%", minHeight: "80px"}}
                                        />
                                    </Th_title>
                                </tr>
                                </tbody>
                            </DetailKvTable>
                        </DetailPanel>
                        }
                        aside={
                        <DetailFilePanel
                            title="첨부"
                            isEditing
                            pendingFiles={{files: docs, setFiles: setDocs}}
                            pendingInputId="purchase_create_doc"
                        />
                        }
                    />
                </div>
            </DetailListPage>
        </DetailFormPageShell>
    );
}

export default PurchaseCreate;
